// extracted by mini-css-extract-plugin
export default {"card":"Intro-module__card-Z3WNQq","fade-in":"Intro-module__fade-in-dz8ZqS","introButton":"Intro-module__introButton-PeFoxw"};